import React from "react";
import { Check } from "lucide-react";
import { DISCORD_LINK, PATREON_LINK } from "@/constants";

const freePlanFeatures = [
  "Access to selected public channels",
  "Occasional research summaries",
  "Bi-weekly community call (listen-only)",
  "Community guidelines and resources",
];

const innerCircleFeatures = [
  "Full Discord access to all channels",
  "All research write-ups and deep dives",
  "Bot calls for short-term trades for various markets",
  "Deeper Q&A access with core team",
  "Early access to new tools or dashboards",
  "Priority support and feedback",
];

const MembershipSection = () => {
  return (
    <section
      id="membership"
      data-testid="membership-section"
      className="py-20 md:py-32 bg-ics-navy"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="section-divider mx-auto" />
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-ics-white mb-4">
            Membership Options
          </h2>
          <p className="text-ics-gray max-w-2xl mx-auto">
            Choose the level that fits your needs. Both tiers provide value while 
            maintaining our commitment to ethical research.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Free Circle Plan */}
          <div
            data-testid="membership-plan-0"
            className="pricing-card glass-card rounded-2xl p-8"
          >
            <div className="mb-6">
              <h3 className="font-heading text-2xl font-semibold text-ics-white mb-2">
                Free Circle
              </h3>
              <p className="text-ics-orange font-semibold text-lg">
                Free
              </p>
            </div>

            <ul className="space-y-3 mb-8">
              {freePlanFeatures.map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-ics-orange flex-shrink-0 mt-0.5" />
                  <span className="text-ics-gray text-sm">{feature}</span>
                </li>
              ))}
            </ul>

            <a
              href={DISCORD_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="membership-cta-0"
              className="block text-center font-semibold py-3 rounded-full transition-all duration-300 bg-white/5 hover:bg-white/10 text-ics-white border border-white/10"
            >
              Join Free
            </a>
          </div>

          {/* Inner Circle Plan */}
          <div
            data-testid="membership-plan-1"
            className="pricing-card glass-card rounded-2xl p-8 featured orange-glow"
          >
            <div className="mb-6">
              <h3 className="font-heading text-2xl font-semibold text-ics-white mb-2">
                Inner Circle
              </h3>
              <p className="text-ics-orange font-semibold text-lg">
                Join via Patreon
              </p>
            </div>

            <ul className="space-y-3 mb-8">
              {innerCircleFeatures.map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-ics-orange flex-shrink-0 mt-0.5" />
                  <span className="text-ics-gray text-sm">{feature}</span>
                </li>
              ))}
            </ul>

            <a
              href={PATREON_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="membership-cta-1"
              className="block text-center font-semibold py-3 rounded-full transition-all duration-300 bg-ics-orange hover:bg-ics-orange-hover text-white"
            >
              Join Inner Circle on Patreon
            </a>
          </div>
        </div>

        <p className="text-center text-xs text-ics-gray mt-8 max-w-2xl mx-auto">
          This is not investment advice. Membership provides access to educational 
          research content and community discussions only.
        </p>
      </div>
    </section>
  );
};

export default MembershipSection;
